<template>
	<v-dialog v-model="dialog" max-width="520" persistent>
		<v-card>
			<v-card-title class="border_bottom">
				Scarica catalogo {{ platformLabel }}
				<v-spacer></v-spacer>
				<v-btn icon @click="close">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>

			<v-card-text class="pt-4">
				<v-select
					v-model="marketplace"
					:items="marketplaceOptions"
					:loading="loadingMarketplaces"
					label="Marketplace"
					item-text="text"
					item-value="value"
					outlined
					dense
					hide-details="auto"
					:rules="[v => !!v || 'Seleziona un marketplace']"
				></v-select>

				<v-select v-model="format" :items="formatOptions" label="Formato" item-text="text" item-value="value" outlined dense hide-details class="mt-4"></v-select>

				<v-alert type="info" text dense class="mt-4 mb-0">
					Il file viene generato a partire dal report ufficiale di {{ platformLabel }}, che può richiedere qualche minuto. Riceverai una mail e una notifica con il link per scaricarlo.
				</v-alert>
			</v-card-text>

			<v-card-actions class="border_top">
				<v-spacer></v-spacer>
				<v-btn text @click="close">Annulla</v-btn>
				<v-btn color="primary" :disabled="!marketplace" :loading="sending" @click="request">Scarica</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'CatalogDownloadDialog',
	props: {
		value: { type: Boolean, default: false },
		// 'amazon' | 'ebay'
		platform: { type: String, required: true },
		// elenco di riserva, usato se il backend non risponde
		fallbackMarketplaces: { type: Array, default: () => [] },
	},
	data() {
		return {
			marketplace: null,
			format: 'excel',
			sending: false,
			loadingMarketplaces: false,
			// marketplace realmente usati dal profilo, con il numero di pubblicazioni
			activeMarketplaces: [],
			formatOptions: [
				{ text: 'Excel (.xlsx)', value: 'excel' },
				{ text: 'CSV', value: 'csv' },
			],
		};
	},
	computed: {
		dialog: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit('input', val);
			},
		},
		platformLabel() {
			return this.platform === 'ebay' ? 'eBay' : 'Amazon';
		},
		// si mostrano solo i marketplace dove abbiamo davvero pubblicazioni:
		// proporre i 22 marketplace teorici invita solo a sbagliare
		marketplaceOptions() {
			if (this.activeMarketplaces.length === 0) {
				return this.fallbackMarketplaces;
			}
			return this.activeMarketplaces.map(item => {
				const known = this.fallbackMarketplaces.find(option => option.value === item.marketplaceId);
				return {
					text: `${known ? known.text : item.marketplaceId} (${item.total})`,
					value: item.marketplaceId,
				};
			});
		},
	},
	watch: {
		value(opened) {
			if (opened) {
				this.loadMarketplaces();
			}
		},
	},
	methods: {
		async loadMarketplaces() {
			this.loadingMarketplaces = true;
			const res = await this.$store.dispatch('marketplaceCatalog/marketplaces', { platform: this.platform });
			this.loadingMarketplaces = false;
			this.activeMarketplaces = res && !res.error && Array.isArray(res.marketplaces) ? res.marketplaces : [];
		},
		async request() {
			this.sending = true;
			// exportAsync è un mixin globale: mostra già lo snackbar di presa in carico
			const res = await this.exportAsync(this.platform, this.format, { marketplace: this.marketplace });
			this.sending = false;
			if (!(res && res.error)) {
				this.close();
			}
		},
		close() {
			this.dialog = false;
		},
	},
};
</script>
